import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { constant } from '../app.constants';
import { MessageTriggerMode,MessageTriggerModeConst  } from '../models/messaging.enum';
import { CommonService } from './common.service';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class MessageService {

    constructor(private _http: HttpClient, private _commonSer: CommonService) { }
    getMessageLogData(data: any) {
        const reqOptns = {
            headers: new HttpHeaders().set("isSPCBaseUrl", "true").set("isLoadNotReq", "true")
        };
        return this._http.post(constant.POST_MESSAGE_SMSLOG, data, reqOptns);
    }
    getMessageQueueData(data: any) {
        const reqOptns = {
            headers: new HttpHeaders().set("isLoadNotReq", "true")
        };
        return this._http.post(constant.Get_MESSAGE_QUEUE_DATA, data, reqOptns);
    }
    CancelMessage(data: any) {
        return this._http.post(constant.CANCEL_SENDING_MESSAGE, data);
    }
    getAutoRefreshValue() {
        const reqOptns = {
            headers: new HttpHeaders().set("isLoadNotReq", "true")
        };
        return this._http.get(constant.SAVE_QUEUEREFRESH, reqOptns);
    }
    SaveAutoRefreshValue(data: any) {
        return this._http.put(constant.SAVE_QUEUEREFRESH, data);
    }
    GetRefillDueData(data: any) {
        return this._http.post(constant.GET_DATA_REFILL_DUE_MSG, data);
    }
    SendRefillDueData(data: any) {
        return this._http.post(constant.SEND_DATA_REFILL_DUE_MSG, data);
    }
    ValidatePhone(phoneNumber) {
        return this._http.get<string>(
            constant.GET_VALIDATE_PHONE.replace("{phoneNumber}", "" + phoneNumber)
        );
    }
    // Secure Patient communication
    postMessageConversation(data: any) {
        const reqOptns = {
            headers: new HttpHeaders().set("isSPCBaseUrl", "true")
        };
        return this._http.post(constant.POST_MESSAGE_CONVERSATION, data, reqOptns);
    }

    postMessageChatSummary(data: any) {
        const reqOptns = {
            headers: new HttpHeaders().set("isSPCBaseUrl", "true")
        };
        return this._http.post(constant.POST_MESSAGE_CHATSUMMARY, data, reqOptns);
    }
    isPatientOnline(payload: any): Observable<any> {
        return this._http.post<any>( constant.IS_PATIENT_ONLINE, payload);
    }

    postMessageUnreadCount(data: any) {
        const reqOptns = {
            headers: new HttpHeaders().set("isSPCNoProxyBaseUrl", "true").set("isLoadNotReq", "true")
        };
        return this._http.post(constant.POST_MESSAGE_UNREADCOUNT, data, reqOptns);
    }

    postMessageMarkAsRead(data: any) {
        const reqOptns = {
            headers: new HttpHeaders().set("isSPCNoProxyBaseUrl", "true")
        };
        return this._http.post(constant.POST_MESSAGE_MARKASREAD, data, reqOptns);
    }
    getMessageTriggerModeLabel(mode: MessageTriggerMode | undefined | null) {
        switch (mode) {
            case MessageTriggerMode.Manual:
                return MessageTriggerModeConst.Manual;
            case MessageTriggerMode.Automatic:
                return MessageTriggerModeConst.Automatic;
            default:
                return MessageTriggerModeConst.Manual;
        }
    }
    downloadImage(payload: any){
        const reqOptns = {
            headers: new HttpHeaders().set("docBaseUrl", "true")
        };
        return this._http.post(constant.POST_DOWNLOAD_IMAGE ,  payload, reqOptns);
    }
    paginatedImages(payload: any){
        const reqOptns = {
            headers: new HttpHeaders().set("docBaseUrl", "true")
        };
        return this._http.post(constant.POST_paginatedImages ,  payload, reqOptns);
    }
    isDeletedMessage(msg: string, forUserList?: boolean): boolean {
  if (!msg) return false;
  const m = msg.toLowerCase();
  if (forUserList && m.includes('for you')) return false;
  return m.includes('for everyone');
}

}
